import C from "../constants";

export default {
  getDeal: function (dealId) {
    return {
      types: [C.GET_DEAL_REQUEST, C.GET_DEAL_SUCCESS, C.GET_DEAL_FAIL],
      promise: (client) =>
        client.get(`/api/deals/${dealId}`).then((response) => {
          return response;
        }),
    };
  },

  sendPersonInvitation: function (
    dealId,
    personId,
    personRole,
    investorId = undefined
  ) {
    return {
      types: [
        C.SEND_PERSON_INVITATION,
        C.SEND_PERSON_INVITATION_SUCCESS,
        C.SEND_PERSON_INVITATION_FAIL,
      ],
      promise: (client) =>
        client
          .post(`/api/send-person-invitation`, {
            data: {
              person_id: personId,
              person_role: personRole,
            },
          })
          .then((response) => {
            return {
              dealId: dealId,
              personId: personId,
              user: response.user,
              investorId: investorId,
            };
          }),
    };
  },
};
